import { z } from "zod";

import { nonNegativeNumber } from "../../../utils/zodUtils";
import { commandType } from "./Attributes";

export const Schema = () =>
    z.object({
        type: z.literal(commandType),
        settings: z.object({
            period: nonNegativeNumber,
        }),
    });
